document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector(".collections-list");
  if (!el) return;

  const slidesQty = parseFloat(el.dataset.slides);
  const slidesGap = parseFloat(el.dataset.gap);
  const slidesQtyMobile = parseFloat(el.dataset.slidesMobile);
  const slidesGapMobile = parseFloat(el.dataset.gapMobile);

  var swiper = new Swiper(".collectionsList", {
    breakpoints: {
      0: {
        slidesPerView: slidesQtyMobile,
        spaceBetween: slidesGapMobile,
      },
      900: {
        slidesPerView: 3,
        spaceBetween: slidesGap,
      },
      1200: {
        slidesPerView: slidesQty,
        spaceBetween: slidesGap,
      },
    },
  });
});
